<template>
  <section class="py-3">
    <v-container text-xs-center>
      <div :style="{ maxWidth: '720px', minWidth: '580px', position: 'relative', left: canvasLeft }">
        <canvas ref="radar" />
      </div>
      <div style="width: 720px; position: absolute; visibility: hidden;">
        <canvas ref="hiddenRadar" />
      </div>
      <v-btn style="color: #3b5998;" outline :loading="loading" @click="share">
        <img src="../assets/fb.png" alt="" height="14" class="mr-2"> 分享至 Facebook
      </v-btn>
    </v-container>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { PROGRAMS } from '../functions/Program';
import { uploadImage } from '../functions/uploadImage';
import { share2FB } from '../functions/share2FB';
import Chart from 'chart.js';

const radarBase = {
  type: 'radar',
  data: {
    labels: PROGRAMS.map(v => v.name),
    datasets: [{
      backgroundColor: '#AB47BC',
      borderColor: '#AB47BC',
    }],
  },
  options: {
    legend: {
      display: false,
    },
    title: {
      display: true,
      text: '清大學程雷達圖',
      fontSize: 16,
    },
    tooltips: {
      enabled: false,
    },
    scale: {
      ticks: {
        display: false,
        max: 100,
        min: 0,
        stepSize: 20
      },
      pointLabels: {
        fontSize: 14,
        fontColor: 'rgba(0, 0, 0, .6)',
        fontFamily: "'Roboto', 'sans-serif'",
      }
    },
    layout: {
      padding: {
        bottom: 20,
      }
    },
    animation: {
      duration: 0,
    },
  },
};

export default {
  name: 'program-chart',
  data() {
    return {
      loading: false,
      canvasLeft: 0,
      isMounted: false,
    }
  },
  computed: {
    ...mapGetters(['programs', 'menus']),
    dataset() {
      return PROGRAMS.map(v => this.programs[v.name]).map(v => Math.min(Math.round(v.doneCredit / v.minCredit * 100), 100));
    },
  },
  watch: {
    programs() {
      if (this.isMounted) this.chart();
    }
  },
  methods: {
    chart() {
      const option1 = JSON.parse(JSON.stringify(radarBase));
      option1.data.datasets[0].data = this.dataset;
      option1.options.animation.onComplete = () => setTimeout(() => {
        if (this.updated()) this.upload();
      }, 100);
      new Chart(this.$refs.hiddenRadar, option1);

      const option2 = JSON.parse(JSON.stringify(radarBase));
      option2.data.datasets[0].data = this.dataset;
      option2.options.scale.pointLabels.fontSize = this.$vuetify.breakpoint.xs ? 12 : 14;
      option2.options.title.fontSize = this.$vuetify.breakpoint.xs ? 14 : 16;
      new Chart(this.$refs.radar, option2);      
    },
    updated() {
      const stored = localStorage.getItem('dataset')
      const current = this.dataset.toString();
      const zero = new Array(12).fill(0).toString();
      const example = '0,50,100,80,0,0,0,0,0,0,33,73';

      if (stored === null || current === zero) {
        localStorage.setItem('dataset', zero);
        localStorage.setItem('imageUrl', 'https://i.imgur.com/AYHwYSV.png');
      } else if (current === example) {
        localStorage.setItem('dataset', example);
        localStorage.setItem('imageUrl', 'https://i.imgur.com/Bc762JL.png');
      }

      return current !== zero && current !== stored && current !== example;
    },
    async upload() {
      this.loading = true;
      try {
        const dataUrl = this.$refs.hiddenRadar.toDataURL('image/png');
        const imageUrl = await uploadImage(dataUrl);
        console.log(imageUrl);
        localStorage.setItem('imageUrl', imageUrl);
        localStorage.setItem('dataset', this.dataset.toString());
      } catch (error) {
        console.log('error');
      } finally {
        this.loading = false;
      }
    },
    share() {
      this.loading = true;
      const imageUrl = localStorage.getItem('imageUrl');
      const text = this.menus[0].doneCredit > 0 ? `我最適合的清大學程是：${this.menus[0].name}` : '清大學程小幫手';
      share2FB(text, imageUrl, res => this.loading = false);
    },
  },
  mounted() {
    this.isMounted = true;
    this.chart();
    this.canvasLeft = `calc((100% - ${this.$refs.radar.clientWidth}px) / 2)`;
  },
}
</script>
